import { createFileRoute } from "@tanstack/react-router";
import { ReportPage } from "@/features/reports/ReportPage";

// X21-OPS-05: presentation mode for a report. Lives beside `$report.tsx`, which renders no child outlet, so the path is
// /reports/present/:report rather than /reports/:report/present.
export const Route = createFileRoute("/_app/reports/present/$report")({ component: Page });

function Page() {
  const { report } = Route.useParams();
  return <ReportPage id={report} present />;
}
